module.exports = __webpack_public_path__ + "img/Clinica_Especializada_Condesa.5d4eb652.jpeg";